'use client';

import React from 'react';

type InputFieldProps<T = string> = {
    name: T;
    label: string;
    value: any;
    type?: string;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    onBlur: (field: T) => void;
    error?: boolean;
    className?: string;
    required?: boolean;
    disabled?: boolean; // <-- Add this line
};

const
    InputField = <T extends string>({
        name,
        label,
        value,
        type = 'text',
        onChange,
        onBlur,
        error,
        className,
        required = true,
        disabled = false,
    }: InputFieldProps<T>) => (
        <div className={`relative ${className || ''}`}>
            <input
                id={String(name)}
                name={String(name)}
                type={type}
                value={value}
                onChange={onChange}
                onBlur={() => onBlur(name)}
                placeholder=" "
                required={required}
                aria-invalid={!!error}
                disabled={disabled} // <-- Add this line
                className={`peer block w-full px-3 pt-3 pb-1 border rounded-md !focus:outline-none bg-white text-gray-900 text-16
        ${error ? 'border-red-500' : 'border-gray-400'}
        focus:border-gray-400

        ${disabled ? 'disabled:cursor-not-allowed' : ''}
    `}
            />
            <label
                htmlFor={String(name)}
                className={`absolute left-3 bg-white px-1 transition-all duration-200
        ${value
                        ? 'text-16 font-normal -top-2.5 translate-y-0'
                        : 'top-1/2 -translate-y-1/2 text-16 font-normal'
                    }
        peer-focus:text-16 peer-focus:-top-2.5 peer-focus:translate-y-0
        peer-placeholder-shown:text-16 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2
        ${error ? 'text-red-500' : 'text-gray-500'}
    `}
            >
                {label}
            </label>
        </div>
    );

export default InputField;